import PropTypes from "prop-types";
import { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper } from "swiper/react";

import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css";

import Title from "components/atoms/Title";

/** ========== */
const FinancialSlider = ({ thetitle, children, ...props }) => {
  const swiper = {
    preloadImages: false,
    lazy: true,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    allowTouchMove: false,
    pagination: {
      el: ".bbc-slide-pagination",
      clickable: true,
      bulletClass: "bbc-pagination-bullet",
      bulletActiveClass: "bg-bbc-brand-700 opacity-100",
    },
    slidesPerView: 3,
    spaceBetween: 30,
    // Responsive breakpoints
    breakpoints: {
      1280: {
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerGroup: 3,
        autoplay: false,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerGroup: 3,
        autoplay: false,
        allowTouchMove: false,
      },

      320: {
        slidesPerView: 1,
        spaceBetween: 40,
        slidesPerGroup: 1,
        autoplay: {
          delay: 2500,
          disableOnInteraction: true,
        },
        allowTouchMove: true,
      },
    },
  };

  return (
    <div className={"relative"}>
      {thetitle && (
        <Title className="title-h2 mb-10 pb-0 text-center text-bbc-brand-800">
          {thetitle}
        </Title>
      )}

      <Swiper
        modules={[Autoplay, Navigation, Pagination]}
        {...swiper}
        {...props}
        className="px-2"
      >
        {children}
        <div className="bbc-slide-pagination relative bottom-0 block pt-6 text-center lg:invisible"></div>
      </Swiper>
    </div>
  );
};

export default FinancialSlider;

FinancialSlider.propTypes = {
  thetitle: PropTypes.string,
  children: PropTypes.any,
};

FinancialSlider.defaultProps = {
  thetitle: null,
};

/** ========== */
